module.exports = __webpack_public_path__ + "img/MAOT_DB_Management_System_snb.b5fefa2f.svg";